var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshTwo = function SvgRefreshTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.333 9.341s.081.567 2.424 2.91a6 6 0 0 0 10.094-2.91m-12.518 0v4m0-4h4m9.334-2.666s-.081-.566-2.424-2.91a6 6 0 0 0-10.094 2.91m12.518 0v-4m0 4h-4"
  })));
};
export default SvgRefreshTwo;